import { mergeTailwindClasses } from '@kontentino/ui';
import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'> & {
  isActiveMenu?: boolean;
};

export const VerticalMenuItemWrapper = forwardRef<HTMLDivElement, Props>(
  ({ children, isActiveMenu, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={mergeTailwindClasses(
        clsx(
          'tw-group tw-relative tw-flex tw-h-8 tw-items-center tw-justify-center',
          {
            'tw-text-primary-100': isActiveMenu,
          },
          className,
        ),
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);
